import React, { Component } from 'react'
import axios from 'axios';

require(`../assets/${process.env.PAGE}/css/components/camera.css`);
import frontIcon from '../assets/common/renaper/frente_seleccionado.png';

import RenaperStepErrorMessage from './RenaperStepErrorMessage';
import DocumentCamera from './DocumentCamera';
import CustomSpinner from './CustomSpinner.js';

class RenaperAddFront extends Component {
  constructor(props){
    super(props);

    this.state = {
        file: null,
        loading: false,
        stepError: false,
    }

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(file){

    this.setState({
      ...this.state,
      loading: true,
    });

    const ROOT_URL = process.env.API_URL;

    const config = {
        headers:
            {
                'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken'),
                'Content-Type': 'multipart/form-data'
            }
    };

    const formData = new FormData();

    formData.append('file', file);

    axios.post(`${ROOT_URL}/identity/renaper/add_front`, formData, config)
    .then((response)=> {
      this.props.onFinish();
    })
    .catch((error) => {
      this.setState({
        ...this.state,
        stepError: true
      })
      setTimeout(this.props.onRollback, 5 * 1000);
    });
  }

  render() {
    const { loading, stepError } = this.state;

    const errorMessage = (<RenaperStepErrorMessage/>);

    return (
      <div style={{
        position: "fixed",
        left: 0,
        top: 0,
        height: "100%",
        width: "100%",
        background: "#000",
      }} >
        <DocumentCamera
            headerTitle="Frente"
            headerIcon={frontIcon}
            onChange={this.handleChange}
            shapeStyle={{
                aspectRatio: 1,
                defaultFixedSide: 'height',
                borderRadius: '15px',
            }}/>
         {loading && <CustomSpinner message={ stepError ? errorMessage : 'Estamos analizando los datos. Por favor espere...' } />}
      </div>)
  }
}
module.exports = RenaperAddFront;


/** WEBPACK FOOTER **
 ** ./src/components/RenaperAddFront.js
 **/